import React from "react";

export default function Error({ message }) {
  return (
    <p 
      style={{color: "red", textAlign: "center", fontSize: 16}}
    >{message}</p>
  )
}